import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/Common/PrivateRoute';
import Navbar from './components/Common/Navbar';
import Footer from './components/Common/Footer';

// Pages
import Login from './pages/Login';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Unauthorized from './pages/Unauthorized';

// Admin Components
import UserManagement from './components/Admin/UserManagement';
import SMSManagement from './components/Admin/SMSManagement';

// Module Components
import ARAModule from './components/ARA/ARAModule';
import ESSIEModule from './components/ESSIE/ESSIEModule';

import './styles/App.css';
import './styles/Responsive.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <div className="main-content">
            <Routes>
              {/* Route publique */}
              <Route path="/login" element={<Login />} />

              {/* Routes protégées */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />

              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />

              {/* Routes Admin */}
              <Route
                path="/admin/users"
                element={
                  <PrivateRoute requireAdmin={true}>
                    <UserManagement />
                  </PrivateRoute>
                }
              />

              <Route
                path="/admin/sms"
                element={
                  <PrivateRoute requireAdmin={true}>
                    <SMSManagement />
                  </PrivateRoute>
                }
              />

              {/* Routes Module ARA */}
              <Route
                path="/ara"
                element={
                  <PrivateRoute requireModule="ARA">
                    <ARAModule />
                  </PrivateRoute>
                }
              />

              {/* Routes Module ESSIE-EHOUN */}
              <Route
                path="/essie-ehoun"
                element={
                  <PrivateRoute requireModule="ESSIE-EHOUN">
                    <ESSIEModule />
                  </PrivateRoute>
                }
              />

              {/* Route non autorisée */}
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Redirection par défaut */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
